<section>
    <div class="title mb-4">
        <h2>Manage FAQ</h2>
        <p style="font-size: 0.6rem;"><q>Tool to manage FAQ</q></p>


        <section class="mt-2">
            <!-- Section Tabs Management -->
            <ul class="nav nav-tabs">
                <li class="nav-item" *ngFor="let section of sections; let i = index">
                    <a class="nav-link" [class.active]="activeTab === section.id"
                        (click)="setActiveTab(section)">
                        {{ section.sectionName }}
                        <span class="section-action ml-5">
                            <i class="fa fa-pencil" (click)="openSectionModal(section)"></i>
                            <i class="fa fa-trash ml-2" (click)="deleteSection(section.id)"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item ">
                    <a class="nav-link add-section" (click)="openSectionModal()">
                        <!-- Button to Add a New Section -->

                        <i class="fa fa-plus-circle" aria-hidden="true"> </i>Add Section

                    </a>
                </li>
            </ul>



            <!-- FAQs Table -->
            <div class="mt-4">
                <button class="btn btn-secondary mt-2" (click)="openFaqModalForAddEdit()">
                    <i class="fa fa-plus-circle" aria-hidden="true"></i> Add FAQ
                </button>

                <table class="table table-hover white_box shadow mt-2">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Question</th>
                            <th>Answer</th>
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let faq of filteredFaqs; let i = index">
                            <th>{{ i + 1 }}</th>
                            <td>{{ faq.question }}</td>
                            <td>{{ faq.answer }}</td>
                            <td class="text-center">
                                <button class="btn btn-info" (click)="openFaqModalForAddEdit(faq)">
                                    <i class="fa fa-pencil"></i> Edit
                                </button>
                                <button class="btn btn-danger ml-2" (click)="deleteFaq(faq.id)">
                                    <i class="fa fa-trash"></i> Delete
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <!-- Add/Edit FAQ Modal -->
        <ng-template #faqModal let-modal>

            <div class="modal-header">
                <h4 class="modal-title">FAQ</h4>
                <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
            </div>
            <div class="modal-body">


                <form [formGroup]="faqForm">
                    <div class="form-group">
                        <label for="question">Question</label>
                        <input type="text" formControlName="question" class="form-control" id="question"
                            placeholder="Enter FAQ question" />
                    </div>

                    <div class="form-group">
                        <label for="answer">Answer</label>
                        <textarea rows="8" formControlName="answer" class="form-control"
                            placeholder="Enter FAQ answer"></textarea>
                    </div>

                    <div class="form-group">
                        <label for="answer">Order</label>
                        <input type="text" formControlName="order" class="form-control" id="order"
                        placeholder="Enter FAQ order" />
                    </div>

            

                    <div class="text-right">
                        <button class="btn btn-secondary" (click)="modalDismissAll()">
                            <i class="fa fa-times"></i> Cancel
                        </button>
                        <button class="btn btn-primary ml-2" [disabled]="isSaving" (click)="saveFaq()">
                            <i *ngIf="!isSaving" class="fa fa-save"></i>
                            <i *ngIf="isSaving" class="fa fa-spinner fa-spin"></i> 
                            <span *ngIf="!isSaving"> Save</span>
                            <span *ngIf="isSaving">Saving...</span>
                          </button>
                    </div>
                </form>

            </div>
        </ng-template>

        <!-- Add/Edit Section Modal -->
        <ng-template #sectionModal let-modal>

            <div class="modal-header">
                <h4 class="modal-title">Section</h4>
                <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
            </div>
            <div class="modal-body">


                <form [formGroup]="sectionForm">
                    <div class="form-group">
                        <label for="sectionName">Section Name</label>
                        <input type="text" formControlName="name" class="form-control" id="sectionName"
                            placeholder="Enter section name" />
                    </div>

                    <div class="form-group">
                        <label for="sectionName">Description</label>
                        <input type="text" formControlName="description" class="form-control" id="sectionName"
                            placeholder="Enter section name" />
                    </div>


                    <div class="text-right">
                        <button class="btn btn-secondary" (click)="modalDismissAll()">
                            <i class="fa fa-times"></i> Cancel
                        </button>
                        <button class="btn btn-primary ml-2" (click)="saveSection()">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>


            </div>


        </ng-template>




    </div>